export default {
  labels: {
    radius: 'Radius',
  },
};
